<template>
  <FClipboard :text="text" @success="handleSuccess">
    <span style="color: #07c160;">Copy</span>
  </FClipboard>
</template>

<script>
import FClipboard from '@flash-component/f-clipboard'
import { Toast } from 'mand-mobile'
// 复制组件
export default {
  name: 'Copy',
  components: {
    FClipboard
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSuccess () {
      Toast.info(this.$t('copy success'))
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
